import Quill from 'quill';
//import Parchment from 'parchment';
import BaseModule from 'quill-resize-module/src/modules/BaseModule';
const Parchment = Quill.import('parchment');
const ClassAttributor = Parchment.ClassAttributor
  ? Parchment.ClassAttributor
  : Parchment.Attributor.Class;
const ImageFormatClass = new ClassAttributor('imagestyle', 'ql-resize-style');

const Icons = {
  left: '/static/media/float-left.svg',
  center: '/static/media/float-center.svg',
  right: '/static/media/float-right.svg',
  full: '/static/media/float-full.svg',
  edit: '/static/media/pencil.svg',
};

// src/lib/Toolbar.js

function getImageElement(activeEle) {
  if (!activeEle) return null;
  return activeEle.tagName === 'IMG'
    ? activeEle
    : activeEle.querySelector?.('img');
}

export default class Toolbar extends BaseModule {
  static Icons = Icons;

  static Tools = {
    left: {
      apply(activeEle) {
        const img = getImageElement(activeEle);
        if (img) {
          img.classList.remove('ql-resize-style-left', 'ql-resize-style-center', 'ql-resize-style-right', 'ql-resize-style-full');
          img.classList.add('ql-resize-style-left');
        }
      },
      isApplied(activeEle) {
        const img = getImageElement(activeEle);
        return ImageFormatClass.value(img) === 'left';
      }
    },
    center: {
      apply(activeEle) {
        const img = getImageElement(activeEle);
        if (img) {
          img.classList.remove('ql-resize-style-left', 'ql-resize-style-center', 'ql-resize-style-right', 'ql-resize-style-full');
          img.classList.add('ql-resize-style-center');
        }
      },
      isApplied(activeEle) {
        const img = activeEle?.tagName === 'IMG' ? activeEle : activeEle?.querySelector?.('img');
        return ImageFormatClass.value(img) === 'center';
      }
    },
    right: {
      apply(activeEle) {
        const img = getImageElement(activeEle);
        if (img) {
          img.classList.remove('ql-resize-style-left', 'ql-resize-style-center', 'ql-resize-style-right', 'ql-resize-style-full');
          img.classList.add('ql-resize-style-right');
        }
      },
      isApplied(activeEle) {
        const img = activeEle?.tagName === 'IMG' ? activeEle : activeEle?.querySelector?.('img');
        return ImageFormatClass.value(img) === 'right';
      }
    },
    full: {
      apply(activeEle) {
        const img = getImageElement(activeEle);
        if (img) {
          img.classList.remove('ql-resize-style-left', 'ql-resize-style-center', 'ql-resize-style-right', 'ql-resize-style-full');
          img.classList.add('ql-resize-style-full');
        }
      },
      isApplied(activeEle) {
        const img = activeEle?.tagName === 'IMG' ? activeEle : activeEle?.querySelector?.('img');
        return ImageFormatClass.value(img) === 'full';
      }
    },
    edit: {
      handler(evt, button, activeEle) {
        this.quill.emitter.emit('resize-edit', activeEle, this.blot);
      }
    }
  };

  onCreate() {
    this.toolbar = document.createElement('div');
    this.toolbar.className = 'ql-resize-toolbar';
    this.overlay.appendChild(this.toolbar);
    this._addToolbarButtons();
  }

  async _addToolbarButtons() {
    const Icons = this.constructor.Icons;
    const Tools = this.constructor.Tools;
    const buttons = [];

    for (const t of this.options.tools) {
      const tool = Tools[t] || t;
      if (tool.verify && tool.verify.call(this, this.activeEle) === false) continue;

      const button = document.createElement('button');
      button.type = 'button';
      buttons.push(button);

      try {
        const res = await fetch(Icons[t]);
        const svg = await res.text();
        button.innerHTML = svg;
      } catch {
        button.textContent = t;
      }

      button.addEventListener('click', (evt) => {
        if (tool.handler && tool.handler.call(this, evt, button, this.activeEle) !== true) return;

        buttons.forEach(btn => btn.classList.remove('active'));

        if (tool.isApplied && tool.isApplied.call(this, this.activeEle)) {
  console.log(t, 'is already applied to', this.activeEle);
          const img = getImageElement(this.activeEle);
          if (img) ImageFormatClass.remove(img);
        } else {
          button.classList.add('active');
          console.log('Applying', t, 'to', this.activeEle);
tool.apply && tool.apply.call(this, this.activeEle);
        }

        this.requestUpdate();
      });

      if (tool.isApplied && tool.isApplied.call(this, this.activeEle)) {
        button.classList.add('active');
      }

      this.toolbar.appendChild(button);
    }
  }
}
